<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img :src="iconSrc" height="28" />
      </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu is-active">
      <div class="navbar-start">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link"> Mitarbeiterstatistik </a>

          <div class="navbar-dropdown">
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'treatmentAssignment' }"
              custom
            >
              <a
                class="navbar-item"
                :class="{ 'is-active': $route.name === 'treatmentAssignment' }"
                @click="navigate"
              >
                Behandlungen zuweisen
              </a>
            </router-link>
            <router-link v-slot="{ navigate }" :to="{ name: 'reports' }" custom>
              <a
                class="navbar-item"
                :class="{ 'is-active': $route.name === 'reports' }"
                @click="navigate"
              >
                Berichte
              </a>
            </router-link>
            <router-link v-slot="{ navigate }" :to="{ name: 'import' }" custom>
              <a
                class="navbar-item"
                :class="{ 'is-active': $route.name === 'import' }"
                @click="navigate"
              >
                Import
              </a>
            </router-link>
          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link"> Absetzungsmanagement </a>

          <div class="navbar-dropdown">
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'absetzungen' }"
              custom
            >
              <a
                class="navbar-item"
                :class="{ 'is-active': $route.name === 'absetzung' }"
                @click="navigate"
              >
                Neue Absetzung
              </a>
            </router-link>
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'alleAbsetzungen' }"
              custom
            >
              <a
                class="navbar-item"
                :class="{ 'is-active': $route.name === 'alleAbsetzungen' }"
                @click="navigate"
              >
                Alle Absetzungen
              </a>
            </router-link>
          </div>
        </div>

        <div
          class="navbar-item has-dropdown is-hoverable"
          v-if="this.accountingEnabled"
        >
          <a class="navbar-link"> Buchhaltung </a>
          <div class="navbar-dropdown">
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'ttoolsDatev' }"
              custom
            >
              <a
                class="navbar-item is-tab"
                :class="{ 'is-active': $route.name === 'ttoolsDatev' }"
                @click="navigate"
              >
                ttools -> Datev Belege
              </a>
            </router-link>
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'ttoolsBuchhaltung' }"
              custom
            >
              <a
                class="navbar-item is-tab"
                :class="{ 'is-active': $route.name === 'ttoolsBuchhaltung' }"
                @click="navigate"
              >
                ttools -> Datev Buchungen
              </a>
            </router-link>
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'ttoolsEagle' }"
              custom
            >
              <a
                class="navbar-item is-tab"
                :class="{ 'is-active': $route.name === 'ttoolsEagle' }"
                @click="navigate"
              >
                ttools -> Eagle
              </a>
            </router-link>
          </div>
        </div>
      </div>

      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link"> Einstellungen </a>

          <div class="navbar-dropdown">
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'therapists' }"
              custom
            >
              <a
                class="navbar-item"
                :class="{ 'is-active': $route.name === 'therapists' }"
                @click="navigate"
              >
                Therapeutinnen
              </a>
            </router-link>
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'userManagement' }"
              custom
            >
              <a
                class="navbar-item"
                :class="{ 'is-active': $route.name === 'userManagement' }"
                @click="navigate"
              >
                Nutzerinnen
              </a>
            </router-link>
          </div>
        </div>
        <div class="navbar-item" v-if="user">
          <div class="icon-text has-icons-right">
            <span>{{ user.name }}</span>
            <span class="icon is-link is-hoverable">
              <icon icon="power-off" @click.prevent="performLogout" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      client: process.env.VUE_APP_CLIENT,
    };
  },
  computed: {
    iconSrc() {
      return `/favicon_${this.client}.ico`;
    },
    accountingEnabled() {
      return process.env.VUE_APP_ENABLE_ACCOUNTING === "true";
    },
    ...mapGetters(["user"]),
  },
  methods: {
    ...mapActions(["logout"]),
    performLogout() {
      this.logout("logout").then(() =>
        this.showMessage({
          message: "Sie wurden abgemeldet.",
          type: "warning",
        }),
      );
    },
  },
};
</script>
<style lang="scss" scoped>
nav {
  border-bottom: 1px solid $mainColor;
  padding: 0px 15px;
}
</style>
